import SurveyListingPanel from './surveyListingPanel.container'

export default SurveyListingPanel